<template slot-scope="scope">
  <!-- 发票管理-历史发票 -->
  <dialogModel
    title="历史发票"
    width="1100px"
    :visible.sync="VisibleHistory"
    :footer="false"
    @handleClose="handleClose"
  >
    <div class="dialog-content">
      <el-form
        :model="screenData"
        :inline="true"
        class="screen"
        @submit.native.prevent="handelSearch"
      >
        <el-form-item label="时间：">
          <el-date-picker
            v-model="screenData.value"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
            clearable
            @clear="screenData.value = null"
          >
          </el-date-picker>
        </el-form-item>

        <div class="screen-end">
          <el-form-item label="订单ID：" class="user-Id">
            <div class="size-search">
              <el-input
                maxlength="30"
                v-model="screenData.orderNumber"
                placeholder="请输入订单ID"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="ser-btn public-style"
              @click="handelSearch"
              >搜 索</el-button
            >
            <el-button class="heavy-btn public-style" @click="handelReset"
              >重 置</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <el-table :data="tableData">
        <el-table-column
          prop="orderNumber"
          label="订单ID"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="customerName" label="购买方"> </el-table-column>
        <el-table-column
          prop="customerCreditCode"
          label="统一社会信用代码/身份证"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="invoiceFormatName"
          label="开票格式"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sendTypeName"
          label="发送方式"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.sendType == 2
                ? "邮箱"
                : scope.row.sendType == 3
                ? "企业微信"
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="amount" label="发票金额(元)">
              </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="开票时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span
              v-if="distinguish == 'issue'"
              class="span-Operation"
              @click="handelIssue(scope.row)"
              >代开发票</span
            >
            <span class="span-Operation" @click="handelDetails(scope.row)"
              >详情信息</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
import {
  outInvoices, //已开出历史列表
  inInvoices, //已开入历史列表
} from "../../../../../../assets/api/Agency/Enterprise";
// 引入分页组件

import paging from "../../../.././../../components/paging.vue";
export default {
  props: {
    VisibleHistory: {},
    distinguish: {},
    row: {},
  },

  components: {
    paging,
  },
  data() {
    return {
      screenData: {
        value: null, // 时间（daterange 清空需为 null）
        input: "",
        orderNumber: "", //
      },
      tableData: [{}],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      options: [
        { label: "企业服务", value: "0" },
        { label: "同行代理", value: "1" },
      ], //变更类型选择
    };
  },
  watch: {
    // // // 监听
    VisibleHistory: {
      handler(newSs, old) {
        if (newSs == true) {
          if (this.distinguish == "issue") {
            // 已开出历史
            this.outInvoices();
          } else {
            // 已开入历史
            this.inInvoices();
          }
        } else {
          //退出弹窗当前页数据重置
          this.pagingObj.currentPage = 1;
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    //重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        input: "", //企业名称
        // code: "", //纳税人识别号
        orderNumber: "", //
      };
      if (this.distinguish == "issue") {
        // 已开出历史
        this.outInvoices();
      } else {
        // 已开入历史
        this.inInvoices();
      }
    },
    //搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      if (this.distinguish == "issue") {
        // 已开出历史
        this.outInvoices();
      } else {
        // 已开入历史
        this.inInvoices();
      }
    },
    // 已开入统计列表
    inInvoices() {
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          creditCode: this.row.creditCode,
          startTime: time,
          endTime: timeEnd,
          orderNumber: this.screenData.orderNumber,
        },
      };
      inInvoices(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 已开出统计列表
    outInvoices() {
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          creditCode: this.row.creditCode,
          startTime: time,
          endTime: timeEnd,
          orderNumber: this.screenData.orderNumber,
        },
      };
      outInvoices(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    //点击代开发票
    handelIssue(row) {
      if (!this.$checkAction()) return;
      this.$emit("handelIssue", row);
    },
    // 点击详情
    handelDetails(row) {
      this.$emit("handelDetails", row);
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      if (this.distinguish == "issue") {
        // 已开出历史
        this.outInvoices();
      } else {
        // 已开入历史
        this.inInvoices();
      }
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseHistory");
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 4px;
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #c0c0c0 #f5f5f5;
}
/deep/.el-date-editor {
  box-sizing: border-box !important;
  padding: 0 8px !important;
  width: 100% !important;
}
/deep/.el-range__close-icon {
  line-height: 32px;
  width: 25px;
}

.dialog-content {
  width: 100%;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  box-sizing: border-box;

  .screen {
    margin-bottom: 20px;
    position: relative;
  }

  .el-table {
    border: 1px solid #eeeeee;
  }
  .span-Operation {
    color: #409eff;
    margin-left: 10px;
    cursor: pointer;
  }
  .span-Operation:nth-child(1) {
    margin-left: 0px;
  }

  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
